'use client';
import { jsx } from 'react/jsx-runtime';
import { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { ProgressiveImageBase } from './progressive-image-base.component.js';
import { ErrorBoundary } from '../error-boundary/error-boundary.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
function _object_without_properties(e, r) {
    if (null == e) return {};
    var t, o, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)t = i[o], !(r.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var t, o, n = {}, i = Object.keys(e);
    for(o = 0; o < i.length; o++)t = i[o], r.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const ProgressiveImage = renderWithRef('ProgressiveImage', null, (i, p)=>{
    let { children: l, onError: a, placeholder: u = '', src: b = '', srcSet: f, sizes: y, trigger: m = 'inView', intersectionOptions: O = {
        threshold: 0
    } } = i, d = _object_without_properties(i, [
        "children",
        "onError",
        "placeholder",
        "src",
        "srcSet",
        "sizes",
        "trigger",
        "intersectionOptions"
    ]), [j, _] = useState({
        delay: 0,
        src: null != u ? u : '',
        sizes: void 0,
        srcSet: void 0
    }), { ref: g, inView: w } = useInView(_object_spread_props(_object_spread({}, O), {
        triggerOnce: true
    }));
    useEffect(()=>{
        'immediate' === m || 'inView' === m && w ? _({
            src: b,
            srcSet: f,
            sizes: y,
            delay: 0
        }) : 'number' == typeof m && _({
            src: b,
            srcSet: f,
            sizes: y,
            delay: m
        });
    }, [
        m,
        b,
        f,
        y,
        w
    ]);
    let h = new Set([
        'swan-progressive-image-wrapper'
    ]);
    return jsx(ErrorBoundary, {
        fallback: l({
            src: b
        }, false),
        children: jsx(RenderComp, {
            root: "div",
            forwardedRef: g,
            props: d,
            classNames: h,
            children: jsx(ProgressiveImageBase, {
                src: j.src,
                placeholder: null != u ? u : '',
                srcSetData: {
                    srcSet: j.srcSet || '',
                    sizes: j.sizes || ''
                },
                delay: j.delay,
                onError: (e)=>{
                    a && a(e);
                },
                children: (e, r, t)=>l({
                        src: e,
                        srcSet: null == t ? void 0 : t.srcSet,
                        sizes: null == t ? void 0 : t.sizes
                    }, 'immediate' !== m && 'inView' === m && !w || r)
            })
        })
    });
});

export { ProgressiveImage };
